import styled, {css} from "styled-components"

export const AccountImage = styled.img`
  ${({theme}) => css`
    height: 100%;
    margin-right: ${theme.spacing.one};
    width: ${theme.spacing.five};
  `}
`
